import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsNearbyTrailClickedParams = {
  destination_trail_id?: number;
  source_section?: string;
  trail_id: number;
};

/**
 * User clicks on a nearby trail from a trail details page.
 * @param params - Attributes to log with the amplitude event
 * @param params.destination_trail_id - The trail id of the nearby trail selected.
 * @param params.source_section - The section on the trail details page from which the nearby trail click originated.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsNearbyTrailClicked = (
  { destination_trail_id, source_section, trail_id }: logTrailDetailsNearbyTrailClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details nearby trail clicked',
    { 'destination trail id': destination_trail_id, 'source section': source_section, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsNearbyTrailClicked;
